const cities = [
  { name: "West Palm Beach", zips: "33401" },
  { name: "Palm Beach", zips: "33480" },
  { name: "Riviera Beach", zips: "33404" },
  { name: "Lake Worth Beach", zips: "33460" },
  { name: "Boynton Beach", zips: "33426" },
  { name: "Greenacres", zips: "33413" },
  { name: "Royal Palm Beach", zips: "33411" },
  { name: "Wellington", zips: "33414" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from home or work in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle the rest.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function WestPalmLocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving West Palm Beach &amp; Palm Beach County
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are in downtown West Palm Beach, Lake Worth, Boynton Beach, or anywhere in Palm Beach County, Fast Passport Center makes expedited passport processing simple — no drive to Miami, no agency lines, no guessing.
          </p>
        </div>

        {/* Full-width editorial intro */}
        <div className="bg-white rounded-lg border border-gray-200 p-6 md:p-8 mb-12">
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            West Palm Beach sits at the heart of Palm Beach County — a vibrant urban center that serves as the gateway to everything South Florida has to offer. While Palm Beach Island across the Royal Park Bridge carries the gilded reputation of old-money estates and yacht clubs, West Palm Beach has forged its own distinct identity as the county&apos;s commercial, cultural, and transportation hub. Downtown Clematis Street pulses with restaurants, bars, and live music venues that draw young professionals and families from across the county. Rosemary Square (formerly CityPlace) anchors the retail and entertainment district with national brands, boutique shops, and a steady calendar of community events.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            The Norton Museum of Art — recently expanded into one of the most significant art institutions in the Southeast — and the Kravis Center for the Performing Arts bring world-class exhibitions, Broadway touring productions, and symphony performances to a city of roughly 120,000 residents. The Palm Beach County Convention Center hosts trade shows, medical conferences, and corporate events that bring business travelers from across the country and abroad. Northwood Village, with its emerging arts district and eclectic dining scene, has become a magnet for creative professionals and entrepreneurs who are redefining what West Palm Beach means in the 2020s.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Palm Beach International Airport (PBI) — located within West Palm Beach city limits — is the most efficient airport in South Florida for both commercial and private aviation. Unlike the sprawling chaos of Miami International or Fort Lauderdale-Hollywood, PBI offers direct international service, shorter security lines, and proximity that matters when you are racing against a departure deadline. The Flagler District continues to develop as a walkable mixed-use corridor connecting downtown to the waterfront, while the Intracoastal Waterway runs through the city providing boating access for residents who live along its shores.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            West Palm Beach&apos;s population is notably more diverse and younger than its island neighbor across the bridge. The city has a significant Hispanic community, a growing tech and startup sector, and a working-class foundation that keeps it grounded in practical realities. Families here are more likely to be planning a Caribbean cruise from Port Everglades or a spring break trip to Cancun than a trans-Atlantic yacht itinerary. Young professionals may need a passport renewed for a business trip to Latin America or a long weekend in Tulum. The arts patrons who support the Kravis Center and Norton Museum often travel to New York, London, and Paris for gallery openings, theater premieres, and cultural festivals.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            What unites all of these travelers is the same pressure: West Palm Beach residents live in a city where international travel is normal, expected, and often planned on short notice. A cruise departure from Fort Lauderdale, a business meeting in Sao Paulo, a Kravis Center cultural exchange trip to Europe — these trips do not accommodate three-month government processing timelines. When a passport expires or gets damaged days before a planned departure, standard processing is not an option.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
            Fast Passport Center has processed expedited passports for West Palm Beach travelers across every demographic and travel scenario. We understand that a young professional flying PBI to Mexico City for a client meeting has the same urgency as a family of four leaving on a Caribbean cruise. Our courier-based expedited service means you start online from your downtown condo, your Northwood Village bungalow, or your Royal Palm Beach home — and your passport arrives within days, not months.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left — FPC Office + How It Works */}
          <div>
            {/* FPC Office Card */}
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-building-2-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Delray Beach</p>
                  <p className="text-white/60 text-xs mt-0.5">401 W Atlantic Ave #351, Delray Beach, FL 33444</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Nearest office to West Palm Beach — approximately 15 miles south on I-95
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout Palm Beach County</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home or office in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location, or <strong className="text-white">schedule a drop-off</strong> at our Delray Beach office. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            {/* How FPC Helps */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-white rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Cities We Serve + Trust strip */}
          <div>
            <div className="bg-white rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities &amp; Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-[#F7F8FA] rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Palm Beach County — start online, ship overnight, and we handle the rest. No need to drive to Miami.
              </p>
            </div>

            {/* Internal links */}
            <div className="bg-white rounded-lg p-5 mb-6 border border-gray-200">
              <p className="text-gray-400 text-xs font-semibold uppercase tracking-widest mb-3">Nearby Cities We Serve</p>
              <div className="flex flex-wrap gap-2">
                {[
                  { name: "Palm Beach", href: "/palm-beach" },
                  { name: "Boca Raton", href: "/boca-raton" },
                  { name: "Delray Beach", href: "/delray-beach" },
                  { name: "Jupiter", href: "/jupiter" },
                  { name: "Palm Beach Gardens", href: "/palm-beach-gardens" },
                  { name: "Wellington", href: "/wellington" },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-[#F7F8FA] border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                  >
                    {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Trust credentials strip */}
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}